import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ExternalLogin, ExternalLoginCreate, ExternalLoginFilter } from '../data/externalLogin';

export function createExternalLoginService(client: AxiosInstance) {
  return createCrudService<ExternalLogin, ExternalLoginCreate, ExternalLoginFilter>(
    client,
    '/identity/ExternalLogin',
    'id',
  );
}

export type ExternalLoginService = CrudService<ExternalLogin, ExternalLoginCreate, ExternalLoginFilter>;
